import React, { useEffect } from 'react'
import aboutimg2 from '../../assets/images/home_about.jpg'

import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';

const HomeAbout2 = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='HomeAbout_section HomeAbout2_section'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-6  text-center m-auto' data-aos="zoom-in" data-aos-duration="2000">

                        <img src={aboutimg2} className='img-fluid' />


                    </div>
                    <div className='col-md-6 HomeAbout_section_content'>
                        <p className='HomeAbout_section_fpcontent' data-aos="fade-up" data-aos-duration="2000">Introduction</p>
                        <h3>About <span style={{ color: "#e65753" }} data-aos="fade-up" data-aos-duration="2000" className='teste2'>Hamo Tech</span></h3>

                        <p data-aos="fade-up" data-aos-duration="2000" className='text-justify'>At Hamo Tech, we are committed to bridging the gap between education and industry needs. Our expert-designed courses in React, Node.js, Java, AWS, .NET, DevOps, and more empower learners to achieve their career aspirations. With a focus on practical learning and hands-on projects, we ensure our students are job-ready from day one. Join us to gain the skills, knowledge, and confidence to excel in the ever-evolving tech world.</p>
                        <p data-aos="fade-up" data-aos-duration="2000" className='text-justify'>Founded with a vision to create tech leaders of tomorrow, Hamo Tech stands as a beacon of quality education and innovation. Our team of experienced instructors and mentors provide personalized guidance, ensuring every learner achieves their full potential. Whether you’re starting your career or upskilling, we offer flexible learning paths tailored to your needs. Together, let’s build a brighter, tech-driven future.</p>



                        <Link to='/user-about'><button>Read More <span><i class="ri-arrow-right-line"></i></span></button></Link>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default HomeAbout2

